/* eslint-disable no-template-curly-in-string */
import { object, string, array } from 'yup';

export const createCategoryValidationSchema = object().shape({
    name: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required'),
    childCategories: array()
        .of(
            object()
                .shape({
                    name: string()
                        .min(2, ('Too Short!'))
                        .max(50, 'Too Long!'),
                })
        )
        .compact(v => v?.name === '')
});
